
import { useState, useRef } from "preact/hooks";
import { render, createContext } from "preact";
import { Modal, Button } from "react-bootstrap";

export const ConfirmationModalContext = createContext();

const ConfirmationModalProvider = ({ children }) => {
    const [show, setShow] = useState(false);
    const [content, setContent] = useState({});
    const resolver = useRef();


    const showConfirmation = (title, message) => {
        setContent({ title, message });
        setShow(true);

        return new Promise(function (resolve) {
            resolver.current = resolve;
        });
    }

    const handleOK = () => {
        resolver.current && resolver.current(true);

        setShow(false);
    }

    const handleCancel = () => {
        resolver.current && resolver.current(false);

        setShow(false);
    }

    return (
        <ConfirmationModalContext.Provider value={{ showConfirmation }}>
            {children}

            <Modal show={show} onHide={() => setShow(false)} centered>

                <Modal.Header closeButton>
                    <Modal.Title>{content.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {content.message}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleCancel() }>
                        Annuler
                    </Button>

                    <Button variant="primary" onClick={() => handleOK() }>
                        Confirmer
                    </Button>

                </Modal.Footer>

            </Modal>
        </ConfirmationModalContext.Provider>
    );
};

export default ConfirmationModalProvider;
